if (!customElements.get('custom-pencil-case-filling')) {
  customElements.define(
    'custom-pencil-case-filling',

    class CustomPencilCaseFilling extends HTMLElement {
      onCartUpdateUnsubscriber = undefined;
      cart = undefined;
      checkbox = undefined;

      constructor() {
        super();
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.checkbox = this.querySelector(".pencil-case-filling__checkbox_input");
      }

      connectedCallback() {
        this.onCartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          this.cartUpdated.bind(this)
        );
      }

      disconnectedCallback() {
        this.onCartUpdateUnsubscriber();
      }

      cartUpdated({ source, productVariantId }) {
        
        // Only react to add-to-cart events from product form, not from cart items
        if (source !== "product-form") return;

        // Only add pencil case filling if checked
        if (!this.checkbox.checked) return;

        // Current product to add filling for
        const productTitle = this.dataset.productTitle;

        // Quantity: Obtain from the quantity field, as there is no info in the cart updated event
        let quantity = 1;
        const quantityInput = document.getElementById(this.dataset.quantityInputId);
        if (quantityInput) {
          quantity = quantityInput.value;
        }


        // Assemble the pencil case filling line item
        var fillingVariantId = this.dataset.fillingVariantId;
        var fillingItem = {
          'id': fillingVariantId, 
          'quantity': quantity,
          'properties': {
            'Penál': productTitle,
          }
        };

        // Add sections for re-rendering the cart
        if (this.cart) {
          fillingItem['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
          fillingItem['sections_url'] = getCartSectionsUrl();
        }

        // Add the product to cart and re-render the cart from the response
        fetch('/cart/add.js', {
          body: JSON.stringify(fillingItem),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'XMLHttpRequest' 
          },
          method: 'POST'
        })
        .then(response => response.json())
        .then(response => {
          if (this.cart) this.cart.renderContents(response);
        });

      }


    }

  );
}
